<template>
    <v-container fluid class="pt-0">
        <v-row align="start" justify="center">
            <v-col cols="12" sm="12" md="12" class="pb-0">
                <v-card class="elevation-4">
                <v-card-title>
                    <div class="btitle">Agent</div>
                    <div class="flex-grow-1"></div>
                    <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    ></v-text-field>
                    <v-btn color="primary" class="ml-3" @click="$router.push('/agent/createagent')">Create Agent</v-btn>
                </v-card-title>

                <v-overlay v-model="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-card-text>
                    <v-divider></v-divider>
                    
                </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Mobile View -->
        <v-row align="center" justify="center" class="d-md-none d-sm-none">
            <v-col cols="12" sm="12" md="12">
                 <v-card class="elevation-4" v-for="agent in agents">
                     <v-card class="mb-2 bu-maker" @click="bDetail(agent.id)" :data-id="agent.id">
                         <v-card-text>
                              <v-row align="start" justify="center" class="bdr p-5">
                                  <v-col cols="8" sm="8" md="8" align="left" justify="left" class="">
                                      <div class="bsubtitle">{{ agent.name }}</div>
                                      <div class="txt_color">Special Agent</div>
                                      <div class="sCity sAddress">{{ agent.addressLine1 }} {{ agent.addressLine2 }}</div>
                                      <div class="sCity">{{ agent.addressLine3  }} {{ agent.addressLine4 }} {{ agent.addressLine5 }} </div>
                                  </v-col>
                                  <v-col cols="4" sm="4" md="4" class="text-center pt-0">
                                                    

                                                    <div class="" >  
                                                    <v-img :src="agent.photo" width="80" height="80" class="cut rounded-card" contain="true"></v-img>
                                                    </div>
                                  </v-col>
                                  
                              </v-row>
                              <v-row>
                                  <v-col cols="12" sm="12" md="12" class="text-right pt-2">
                                      <v-btn color="primary " class="" @click="editItem(agent.id)" fab x-small dark ><v-icon>mdi-pencil</v-icon></v-btn>
                                  </v-col>
                              </v-row>
                              <v-row align="center" justify="center" v-bind:class="{ 'd-flex': currentAgent==agent.id,'d-none':currentAgent!=agent.id }"  :id="agent.id">

                                  <v-col cols="12" sm="12" md="12" align="left" justify="center">
                                      
                                    <v-row>
                                          <v-col cols="8" sm="8" md="8" align="left" justify="center">
                                            <div class="bsubtitle">{{ agent.name }}</div>
                                            <div class="txt_color">Special Agent</div>
                                            <div class="sCity sAddress">{{ agent.addressLine1 }} {{ agent.addressLine2 }}</div>
                                            
                                      
                                          </v-col>
                                            <v-col cols="4" sm="4" md="4" class="text-center pt-0">
                                                <div class="" >  
                                                    <v-img :src="agent.photo" width="80" height="80" class="cut rounded-card" contain="true"></v-img>
                                                </div>
                                            </v-col>
                                    </v-row>

                                    <v-row>
                                                <v-col cols="3" sm="3" md="3" class="text-center pt-0">
                                                    <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsassigned }} </div>
                                                    <div class="fs-10">Clients</div>
                                                </v-col>

                                                <v-col cols="3" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsused }} </div>
                                                        <div class="fs-10">Issued</div>
                                                        
                                                </v-col>

                                                <v-col cols="3" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsassigned }} </div>
                                                        <div class="fs-10">Assigned</div>
                                                    </v-col>
                                                     <v-col cols="3" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.balance }} </div>
                                                        <div class="fs-10">Balance</div>
                                                </v-col>
                                    </v-row>

                                    <v-row align="center">
                                        <v-col cols="4" sm="4" md="4" align="center" class="text-center pt-0">
                                            <v-icon :color="color" >{{ icon }}</v-icon> 
                                        </v-col>
                                        <v-col cols="4" sm="4" md="4" align="center" class="text-center pt-0">
                                             
                                                    <div class="bsubtitle">ACTIVITY</div>
                                                    
                                                    <div class="fs-12">Last LGO IN :</div>
                                                    <div class="fs-12">{{ agent.lastlogin  }}</div>
                                                
                                        </v-col>
                                    </v-row>
                                      
                                  </v-col>

                              </v-row>
                         </v-card-text>
                     </v-card>
                 </v-card>
            </v-col>
        </v-row>


        <!-- Desktop View -->

        <v-row align="center" justify="center" class="d-none d-md-flex ">
             <v-col cols="12" sm="12" md="12">
                    <v-card class="elevation-4" v-for="agent in agents">
                       
                            <v-card-text class=" pt-0 pb-0 bu-maker" @click="agentDesktopDetail(agent.id)" :data-id="agent.id" style="padding-left:12px !important;padding-right:12px !important;"> 
                                    <v-row align="start" justify="center" class="align-stretch bdr" >
                                        <v-col cols="4" sm="4" md="4" align="left" justify="left" class="brd-right" >
                                            <v-row>
                                                <v-col cols="8" sm="8" md="8" align="left" justify="left" class="pt-0">
                                                    <div class="fs-18 pb-1">{{ agent.name }}</div>
                                                    <div class="txt_color" v-if="agent.agenttype=='Special Agent'">Special Agent</div>
                                                    <div class="pt-1" v-if="agent.businesname!=''"><strong>{{ agent.businesname }}</strong></div>
                                                    <div class="sCity sAddress pt-1">{{ agent.addressLine1 }} {{ agent.addressLine2 }}</div>
                                                    <div class="sCity">{{ agent.addressLine3  }} {{ agent.addressLine4 }} {{ agent.addressLine5 }} </div> 
                                                </v-col>
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="brd-right">
                                                   
                                                    <a :href="'tel:'+agent.mobile" class="txtblck"><v-img :src="phoneIMG" width="21" height="37" class="text-center" style="" contain="true"></v-img></a>
                                      
                                                </v-col>
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                   
                                                    <a :href="'tel:'+agent.mobile" class="txtblck"><v-img :src="smartIMG" width="37" height="37" class="text-center" style="" contain="true"></v-img></a>
                                      
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" align="left" justify="left" class="brd-right">
                                             <v-row>
                                                <v-col cols="6" sm="6" md="6" class="text-center pt-0">
                                                    

                                                    <div class="" >  
                                                    <v-img :src="agent.photo" width="80" height="80" class="cut " contain="true"></v-img>
                                                    </div>
                                                </v-col>
                                                <v-col cols="6" sm="6" md="6" class="text-center pt-0">
                                                    <div class="bsubtitle">ACTIVITY</div>
                                                    <div class="fs-12">Date Registered :{{ agent.datejoined  }}</div>
                                                    <div class="fs-12">Last LGO IN :{{ agent.lastlogin  }}</div>
                                                </v-col>
                                             </v-row>

                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" align="left" justify="left" >
                                                <v-row>
                                                    <v-col cols="12" sm="2" md="2" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsassigned }} </div>
                                                        <div>Clients</div>
                                                    </v-col>

                                                    <v-col cols="12" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsused }} </div>
                                                        <div>Issued</div>
                                                        
                                                    </v-col>

                                                    <v-col cols="12" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.tagsassigned }} </div>
                                                        <div>Assigned</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="3" md="3" class="text-center pt-0">
                                                            <div class="tag-assign-dasktop d-img d-inline-block" 
                                                        :style="{ backgroundImage: `url('${tagIMG} ')` }"> {{ agent.balance }} </div>
                                                        <div>Balance</div>
                                                    </v-col>
                                                    <v-col cols="12" sm="1" md="1" class="text-center pa-0">
                                                        <v-btn color="primary mr-2" class="" @click="editItem(agent.id)" fab x-small dark ><v-icon>mdi-pencil</v-icon></v-btn>
                                                    </v-col>
                                                </v-row>
                                                
                                        </v-col>

                                        
                                    </v-row>

                                    <v-row v-bind:class="{ 'd-flex': currentAgent==agent.id,'d-none':currentAgent!=agent.id }"  :id="agent.id">

                                        <v-col cols="4" sm="4" md="4" align="left" justify="left" class="">
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" align="left" justify="left" class="">
                                                   <div class="bdr-bottom" >{{ agent.name }}</div>

                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" align="left" justify="left" class="">
                                                    <div class="bdr-bottom" >Special Agent</div>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" align="left" justify="left" class="">
                                                    <div class="bdr-bottom" >Recruited By</div>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" align="left" justify="left" class="">
                                                    <div class="bdr-bottom">{{ agent.idType }}</div>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" align="left" justify="left" class="">
                                                    <div class="bdr-bottom">{{ agent.idNumber }}</div>
                                                </v-col>
                                                
                                            </v-row>
                                            <v-row> 
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                     <v-icon :color="color" >mdi-phone</v-icon> 
                                                </v-col>
                                                <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                                   <div class="bdr-bottom">{{ agent.mobile }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row> 
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                    <v-icon :color="color" >mdi-phone-classic</v-icon> 
                                                </v-col>
                                                <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                                   <div class="bdr-bottom">{{ agent.phone }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row> 
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                    <v-icon :color="color" >mdi-whatsapp</v-icon>
                                                </v-col>
                                                <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                                   <div class="bdr-bottom">{{ agent.whatsapp }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row> 
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                    <v-icon :color="color" >mdi-web</v-icon>
                                                </v-col>
                                                <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                                   <div class="bdr-bottom"> {{ agent.website }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row v-for="social in agent.socialmedia">
                                                <v-col cols="2" sm="2" md="2" align="left" justify="left" class="">
                                                    <v-icon :color="color" >{{ social.social_media.icon }}</v-icon>
                                                </v-col>
                                                 <v-col cols="10" sm="10" md="10" align="left" justify="left" class="">
                                                    <div class="bdr-bottom"> {{ social.value }}</div>
                                                </v-col>
                                            </v-row>
                                           
                                        </v-col>

                                        <v-col cols="4" sm="4" md="4" align="left" justify="left" class="">
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        <v-img :src="agent.photo" width="100" height="100" contain="true"></v-img>
                                                    </v-col>

                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        {{ agent.addressLine1 }}
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        {{ agent.addressLine2 }}
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        {{ agent.addressLine3 }}
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        {{ agent.addressLine4 }}
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="12" align-self="center" justify="center">
                                                        {{ agent.addressLine5 }}
                                                    </v-col>
                                                </v-row> 
                                        </v-col>

                                        <v-col cols="4" sm="4" md="4" align="left" justify="left" class="">
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14663.739821056082!2d77.45872335!3d23.245453899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1572949160676!5m2!1sen!2sin" width="300" height="350" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                                        </v-col>


                                    </v-row>
                            </v-card-text>
                            <v-card class="mb-2 blue-grey lighten-4 bu-maker" >
                            
                            </v-card>
                        
                    </v-card>
             </v-col>
        </v-row>

        

    </v-container>
</template>

<script>
export default {
  data: () => ({
      overlay:true,
      icon: 'mdi-phone',
      iconlandline:'mdi-phone-classic',
      iconwhatsapp:'mdi-whatsapp',
      iconweb:'mdi-web',
      iconfb:'mdi-facebook',
      iconinstagram:'mdi-instagram',
      icontwitter:'mdi-twitter',
      iconopen:'mdi-toggle-switch',
      iconclose:'mdi-toggle-switch-off',
      color: 'black',
      colorgreen:'green',
      colorred:'red',
        tagIMG:require("@/assets/Rectangle.png"),
        search: "",
        // phoneIMG:require("@/assets/fb.png"),
        agentStatus:"",
        headerIMG:require("@/assets/Matrix-Header-Logo.png"),
        phoneIMG:require("@/assets/mobile.png"),
        smartIMG:require("@/assets/smartphone.png"),
        landlineIMG:require("@/assets/landline.png"),
        whatsappImg:require("@/assets/whatsaap.png"),
        websiteImg:require("@/assets/website.png"),
        fbImg:require("@/assets/fb-icon.png"),
        tripImg:require("@/assets/trip.png"),
        instagramImg:require("@/assets/instagra.png"),
        twitterImg:require("@/assets/twitter.png"),
        newMsg:require("@/assets/new_message.png"),
        tagIMG:require("@/assets/Rectangle4.png"),
        vectorIMG:require("@/assets/Vector.png"),
        headers: [
        
        { text: "Photo", value: "photo", sortable: false },
        { text: "Name", value: "name" },
        { text: "Home Town/City",value: "hometown"},
        { text: "Phone",value: "phone"},
        { text: "Email", value: "email" },
        { text: "Date Joined", value: "datejoined" },
        { text: "Tags Assigned", value: "tagsassigned",align:"end" },
        { text: "Tags Used", value: "tagsused",align:"end" },
        { text: "Actions", value: "action", sortable: false }
        ],
        statusitem: [{name:"Active",value:"1"}, {name:"InActive",value:"0"}, {name:"Locked",value:"2"}],
        agents: [],
        items: [
            { title: 'Active' },
            { title: 'InActive' },
            { title: 'Locked' },
        
        ],
        aIcon:"",   
        currentAgent:0,
  }),
  created() {
    this.$http
      .get(this.$apidomain+"agent/agentlistspecial/"+this.$user.id)
      .then(res => {
        this.agents = res.data.agents;
        this.overlay=false;
      })
  

      .catch(err => {
        console.log(err.response);
        this.overlay=false;
      });
      
  },
  methods: {
    // phoneItem(item){
    //       window.location.href("tel:"+item.phone);
    // },
    agentDesktopDetail(id){
         if(this.currentAgent==0)
         {
          this.currentAgent=id;
         }else{
           this.currentAgent=0;  
         }
    },
    bDetail(id)
      {

       if(this.currentAgent==0)
         {
          this.currentAgent=id;
         }else{
           this.currentAgent=0;  
         }
        
        
      
      },
    lockedAgent(item)
    {
       console.log("item id "+item.id);
        this.$http
      .post(this.$apidomain+"agentlocked/"+item.id)
      .then(res => {
        if(res.data.success)
        {
          this.agents = res.data.agents;
          this.$router.push('/agentlist');
        }
        
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    inactiveAgent(item){
        console.log("item id "+item.id);
        this.$http
      .post(this.$apidomain+"agentinactive/"+item.id)
      .then(res => {
        if(res.data.success)
        {
          this.agents = res.data.agents;
          this.$router.push('/agentlist');
        }
        
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    activeAgent(item){
        console.log("item id "+item.id);
        this.$http
      .post(this.$apidomain+"agentactive/"+item.id)
      .then(res => {
        if(res.data.success)
        {
          this.agents = res.data.agents;
          this.$router.push('/agent/agentlist');
        }
        
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    editItem(id){
      this.$router.push({name:'editagent',params:{id:id}});
    },
    deleteItem(item) {
        
      
      if (confirm("Are you sure you want to delete this agent?")) {
          this.$http
      .post(this.$apidomain+"deleteagent/"+item.id)
      .then(res => {
        this.agents = res.data.agents;
      })
      .catch(err => {
        console.log(err.response);
      });
      }
    },
    createagent(){
        this.$router.push('/agent/createagent');
    }
  }
};
</script>
<style >
    .p-5{
        padding:5px !important;
    }
  .bdr{
        border:1px solid #c2c2c2;
        border-radius: 4px;
        box-shadow: 3px 3px #c2c2c2;
    }  
  .eHover{
    cursor: pointer;
  }
  .txtblck,.v-application a{
    color: #000 !important;
    text-decoration: none !important;
  }
  .brd-right{
      border-right: 1px solid #e8e8e8;
  }
  .bsubtitle{
      color:#ff5800 !important
  }
  .fs-10{
      font-size: 10px;
  }
  .fs-12{
  font-size: 12px;
}
.fs-18{
    line-height: 1rem;
    font-weight: bold;
    font-size: 18px;
}
.rounded-card{
    border-radius:50px;
}
</style>
    